export const _LOAD_MODEL_ = 'Load:QuotationModel';
export const _OPEN_MODAL_ = 'Open:Quotation';
export const _DELETE_QUOTATION_ = 'Delete:Quotation';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _UPDATE_QUOTATION_ROWS_ = 'Update:UpdateQuotation';
export const _SAVE_QUOTATION_SUCCESS_ = 'Save:QuotationSuccess';
export const _UPDATE_QUOTATION_PRODUCT_ = 'Update:QuotationProduct';

export const STATUS_OPTIONS = [
  { slug: 'open', name: 'Rascunho' },
  { slug: 'pending', name: 'Pendente' },
  { slug: 'approved', name: 'Aprovado' },
  { slug: 'canceled', name: 'Cancelado' },
  { slug: 'closed', name: 'Concluído' },
];

export const EXPOSITION_TYPE_OPTIONS = [
  { id: null, name: null, slug: null },
];

export const PAYMENT_TYPE_OPTIONS = [
  { id: null, name: null, slug: null },
];

export const MODEL_QUOTATION_EQUIPMENT = {
  id: null,
  name: null,
  slug: null,
  quantity: null,
};

export const CUSTOMER = {
  id: null,
  name: null,
  document: null,
  addresses: [],
};

export const ROW = {
  id: null,
  total: 1.00,
  value: 1.00,
  function: null,
  quantity: 1,
  sector: null,
  product: {
    name: null,
    price: null,
  },
  product_type_id: 1,
  exposition_type_id: 1,
};

export const SERVICE_ROW = {
  id: null,
  total: 1.00,
  value: 1.00,
  quantity: 1,
  product: {
    name: null,
    price: null,
  },
};

export const MODEL = {
  id: null,
  rows: [{ ...ROW }],
  services: [{ ...SERVICE_ROW }],
  total: 0.00,
  status: 'open',
  parcel: 1,
  user: {
    name: '',
  },
  type_id: null,
  comment: null,
  valid_at: null,
  discount: 0.00,
  equipments: [{ ...MODEL_QUOTATION_EQUIPMENT }],
  deadlines: null,
  details: null,
  responsible: '',
  created_by: null,
  subtotal: 0.00,
  parcel_value: 0.00,
  payment_info: 'Pagamento em 30 dias',
  discount_type: 'pct',
  customer: { ...CUSTOMER },
  customer_id: '',
  customer_name: '',
  service_address_id: null,
};
